import * as React from 'react';
import Image from 'next/image';

import { cn, customImageLoader } from '@restworld/utils-common';
import { PhotoIcon } from '@heroicons/react/24/solid';

export interface ImageSliderProps {
  images?: string[];
}

export function ImageSlider({ images }: ImageSliderProps) {
  if (!images || !images.length) return <Placeholder />;
  return <SliderGallery images={images} />;
}

const SliderGallery = ({ images }: { images: string[] }) => (
  <SliderWrapper>
    {images?.length ? images.map((v) => <ImageStyled width={235} height={132} key={v} src={v} />) : null}
  </SliderWrapper>
);

const Placeholder = () => (
  <div className="w-full bg-purple-100 grid place-items-center h-32 rounded-lg">
    <PhotoIcon className="h-8 w-8 fill-primary-900" />
  </div>
);

const SliderWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex gap-2 h-full max-w-full overflow-x-auto scrollbar-none', className)} {...props} />
);

const ImageStyled = ({ $customStyle, className, ...props }: any) => (
  <Image
    loader={customImageLoader}
    alt=""
    className={cn('block object-cover object-center w-full rounded-lg min-w-fit h-32', $customStyle, className)}
    {...props}
  />
);

export default ImageSlider;
